<template>
  <div class="h-screen bg-gray-4">
    <div class="container flex flex-col items-center justify-center h-full">
      <h1 class="heading-1 mb-6">{{ title }}</h1>
      <div class="mb-20">
        <img src="@/assets/images/illustration_1.svg" alt="illustration" />
      </div>
      <div
        class="
          absolute
          bottom-0
          left-0
          right-0
          h-52
          bg-white
          drop-shadow-overlay
          filter
        "
      >
        <div class="container">
          <h2 class="heading-1">{{ description }}</h2>
          <Button
            :label="$t('ratingForm.completed.button')"
            class="mt-10"
            block
            @click="goToGoogleMaps"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Button from '@/components/legacy/Button.vue';
import { ReviewsService } from '@/services/reviews.service';

@Component({
  components: {
    Button,
  },
})
export default class FeedbackPositiveView extends Vue {
  private get title(): string {
    return this.$store.getters['positiveReviewTitle'];
  }

  private get description(): string {
    return this.$store.getters['positiveReviewDescription'];
  }

  private goToGoogleMaps() {
    const id = this.$store.state['reviewId'];
    ReviewsService.setGoogleMapsClicked(id);
    const writeReviewUrl = this.$store.state['writeReviewUrl'];
    window.location.href = writeReviewUrl;
  }
}
</script>
